export default __webpack_public_path__ + "locales/lv/DeleteSelfProfileDialog.json?hash=c3628d551eeb5050fcf1a84f5d91e579";